import React from 'react'
import { HeaderContent, HeaderMenu, HeaderMenuItem, LandingHeaderWrapper, MainLogo } from './LandingHeaderStyled'
import { Container } from '../CommonStyled/CommonStyled'
import IMAGES from '../../images'
import 'moment/locale/vi'
import { useRecoilValue } from 'recoil'
import { breakPointState } from '../../recoil/commonState'
import { BREAKPOINT, GREEN_DATA, REDIRECT_LOGO_LINK, VIEW_MODE } from '../../constant'
import MenuIcon from '../MenuIcon'
import { handleClickMenu } from '../../utils/common'
import PropTypes from 'prop-types'
import { MenuOutlined } from '@ant-design/icons'
import { Drawer } from 'antd'

const LandingHeader = props => {
  const { mode, data } = props
  const breakPoint = useRecoilValue(breakPointState)
  const [open, setOpen] = React.useState(false)

  return (
    <LandingHeaderWrapper>
      <Container>
        <HeaderContent>
          {/*<MainLogo*/}
          {/*  style={{ cursor: 'pointer' }}*/}
          {/*  onClick={() => (window.location.href = REDIRECT_LOGO_LINK)}*/}
          {/*  src={IMAGES.WHITE_LOGO}*/}
          {/*  alt={'logo'}*/}
          {/*/>*/}
          <div></div>
          <HeaderMenu>
            {breakPoint === BREAKPOINT.SM || breakPoint === BREAKPOINT.XS ? (
              <>
                <MenuOutlined
                  style={{ color: '#fff', fontSize: 18, fontWeight: 700, marginRight: 16 }}
                  onClick={() => setOpen(true)}
                />
                <Drawer
                  headerStyle={{
                    background: 'linear-gradient(90deg, rgb(33, 64, 129) 0%, rgb(35, 176, 78) 100%)'
                }}
                  bodyStyle={{ background: 'linear-gradient(90deg, rgb(33, 64, 129) 0%, rgb(35, 176, 78) 100%)' }}
                  width={'60%'}
                  title={null}
                  onClose={() => setOpen(false)}
                  open={open}
                >
                  <HeaderMenuItem onClick={() => handleClickMenu(GREEN_DATA.CASH_FLOW.ID, mode, data)}>
                    <MenuIcon />
                    <a>{data?.businessStationConfig?.title}</a>
                  </HeaderMenuItem>
                  <HeaderMenuItem onClick={() => handleClickMenu(GREEN_DATA.E_COMMERCE.ID, mode, data)}>
                    <MenuIcon />
                    <a>{data?.ecommerceStationConfig?.title}</a>
                  </HeaderMenuItem>
                  <HeaderMenuItem onClick={() => handleClickMenu(GREEN_DATA.FINANCE.ID, mode, data)}>
                    <MenuIcon />
                    <a>{data?.financialStationConfig?.title}</a>
                  </HeaderMenuItem>
                  <HeaderMenuItem onClick={() => handleClickMenu(GREEN_DATA.KNOWLEDGE.ID, mode, data)}>
                    <MenuIcon />
                    <a>{data?.knowledgeStationConfig?.title}</a>
                  </HeaderMenuItem>
                </Drawer>
              </>
            ) : (
              <>
                <HeaderMenuItem onClick={() => handleClickMenu(GREEN_DATA.CASH_FLOW.ID, mode, data)}>
                  <MenuIcon />
                  <a>{data?.businessStationConfig?.title}</a>
                </HeaderMenuItem>
                <HeaderMenuItem onClick={() => handleClickMenu(GREEN_DATA.E_COMMERCE.ID, mode, data)}>
                  <MenuIcon />
                  <a>{data?.ecommerceStationConfig?.title}</a>
                </HeaderMenuItem>
                <HeaderMenuItem onClick={() => handleClickMenu(GREEN_DATA.FINANCE.ID, mode, data)}>
                  <MenuIcon />
                  <a>{data?.financialStationConfig?.title}</a>
                </HeaderMenuItem>
                <HeaderMenuItem onClick={() => handleClickMenu(GREEN_DATA.KNOWLEDGE.ID, mode, data)}>
                  <MenuIcon />
                  <a>{data?.knowledgeStationConfig?.title}</a>
                </HeaderMenuItem>
              </>
            )}
          </HeaderMenu>
        </HeaderContent>
      </Container>
    </LandingHeaderWrapper>
  )
}

LandingHeader.propTypes = {
  mode: PropTypes.oneOf([VIEW_MODE.PUBLIC, VIEW_MODE.PREVIEW]).isRequired,
}

export default LandingHeader
